export default "__VITE_PUBLIC_ASSET__b329071c__"